import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import varnamalaLevel from "../../assets/varnamala_level.svg";
import gradeLevel from "../../assets/grade_level.svg";
import useTranslationSetup from "../../utils/useTranslationSetup";
import "./CohortDetailsContent.css";
import { getResultUrlParams } from "../../utils/CommonUtils/constants";
import useParamValues from "../../utils/useParamValues";

const CohortDetailsContent = ({
  icon,
  iconNote,
  students,
  onLearnMore,
  className,
}) => {
  const { t } = useTranslationSetup();
  const shouldShowIconNote = icon && iconNote;
  const navigate = useNavigate();
  const useParamValue = useParamValues();

  return (
    <Box className="cohort-dropdown-content">
      {onLearnMore && (
        <Typography className="cohort-card-description">
          {t("cohort_category_card_desc_text")}
          <span className="cohort-card-link" onClick={onLearnMore}>
            {t("learn_more")}
          </span>
        </Typography>
      )}

      {shouldShowIconNote && (
        <Box className="cohort-note-row">
          <img src={icon} alt="Level" className="cohort-note-icon" />
          <Typography className="cohort-card-note">{iconNote}</Typography>
        </Box>
      )}

      {students.map((student, index) => (
        <Box
          key={index}
          className="student-list-item"
          onClick={() =>
            navigate(`/result?${getResultUrlParams(useParamValue, student)}`, {
              state: { showBack: true },
            })
          }
        >
          <Box className={`student-color-indicator ${className}-border`} />
          <Box className="student-info">
            <Typography className="cohort-student-name">
              {student.name}
              {student.badge === 2 && (
                <img
                  src={varnamalaLevel}
                  alt="Varnamala Level"
                  className="cohort-note-icon"
                />
              )}
              {student.badge === 1 && (
                <img src={gradeLevel} alt="Grade Level" />
              )}
            </Typography>
            <KeyboardArrowRightIcon className="student-arrow" />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default CohortDetailsContent;
